// CustomObject3D.js
import { Object3D } from 'three';

class BehaviourObject extends Object3D {
  constructor(code) {
    
    super();
    this.code = code;
    this.type = 'BehaviourObject';
  }

  clone(recursive = true) {
    const newObject = new BehaviourObject();
    newObject.copy(this, recursive);
    newObject.code = this.code;

    return newObject;
  }

}

export default BehaviourObject;